<template>
    <div class="bg-base-200 flex justify-between flex-col md:flex-row px-4 py-6 md:px-6 xl:px-0 xl:py-10 xl:flex-row md:justify-center xl:justify-between max-w-[1408px] mx-auto">
        <div class="flex justify-around flex-col xl:flex-row xl:w-fit xl:gap-8">
            <component :is="leftComponent" class="md:w-[385px] xl:w-[328px]" :content="leftSlot" />
            <component :is="centerLeftComponent" class="md:w-[385px] xl:w-[328px]" :content="centerLeftSlot" />
        </div>
        <div class="flex justify-around flex-col xl:flex-row xl:w-fit xl:gap-8">
            <component :is="centerRightComponent" class="md:w-[385px] xl:w-[328px]" :content="centerRightSlot" />
            <component :is="rightComponent" class="md:w-[385px] xl:w-[328px]" :content="rightSlot" />
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { HblSlot } from '@/utils/types'
import { hblToUpperCamelCase } from '@/utils/helper'

const props = defineProps<{
    content: HblSlot[]
}>()

const leftSlot = computed(() => {
    return props.content.find(item => item.position === 'left')
})

const centerLeftSlot = computed(() => {
    return props.content.find(item => item.position === 'centerLeft')
})

const centerRightSlot = computed(() => {
    return props.content.find(item => item.position === 'centerRight')
})

const rightSlot = computed(() => {
    return props.content.find(item => item.position === 'right')
})

const leftComponent = computed(() => {
    if (!leftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(leftSlot.value.type)}`
})

const centerLeftComponent = computed(() => {
    if (!centerLeftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerLeftSlot.value.type)}`
})

const centerRightComponent = computed(() => {
    if (!centerRightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerRightSlot.value.type)}`
})

const rightComponent = computed(() => {
    if (!rightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(rightSlot.value.type)}`
})
</script>
